import { IntegrationSource, IntegrationSourceParser } from './integrationSource';
import integrationSourceEG from './intSrcEg';

export default {
  IntegrationSource,
  IntegrationSourceParser,
  integrationSourceEG,
};
